import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    personal: {},
    residentes: {},
    centros: {},
    usuarios: {},
    isDark: localStorage.getItem('theme') === 'dark',
    usuarioActivo: {
      imagen: "",
      nombre: "",
      descripcion: ""
    }
  },
  mutations: {
    toggleTheme(state) {
      state.isDark = !state.isDark;
      localStorage.setItem('theme', state.isDark ? 'dark' : 'light');
    },
    setPersonal(state, payload){
      state.personal=payload;
    },
    getPersonal(state){
      return state.personal
    },
    setResidentes(state, payload){
      state.residentes=payload;
    },
    getResidentes(state){
      return state.residentes
    },
    setCentros(state, payload){
      state.centros=payload;
    },
    getCentros(state){
      return state.centros
    },
    setUsuarios(state, payload){
      state.usuarios=payload;
    },
    getUsuarios(state){
      return state.usuarios
    },
    setUsuarioActivo(state,payload){
      state.usuarioActivo=payload
    },
    getUsuarioActivo(state){
      return state.usuarioActivo
    }
  },
  actions: {
    accionSetPersonal({ commit}, per){
      commit('setPersonal', per)
    },
    accionGetPersonal({ commit}){
      commit('getPersonal')
    },
    accionSetResidentes({ commit}, res){
      commit('setResidentes', res)
    },
    accionGetResidentes({ commit}){
      commit('getResidentes')
    },
    accionSetCentros({ commit}, cen){
      commit('setCentros', cen)
    },
    accionGetCentros({ commit}){
      commit('getCentros')
    },
    accionSetUsuarios({ commit}, usu){
      commit('setUsuarios', usu)
    },
    accionGetUsuarios({ commit}){
      commit('getUsuarios')
    },
    accionSetUsuarioActivo({ commit},usuA){
      commit('setUsuarioActivo',usuA)
    },
    accionGetUsuarioActivo({ commit}){
      commit('getUsuarioActivo')
    }
  },
  modules: {
  }
})
